class LiveSearchWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    this.liveSearch = this.querySelector("live-search");
    this.close = this.querySelector("[data-close]");
    this.clear = this.querySelector("[data-clear]");

    if (!this.input || !this.liveSearch) return;

    this.toggleClearVisibility();

    this.input.addEventListener("input", () => {
      this.setAttribute("interacting", "");
      this.liveSearch.setAttribute("q", this.input.value);
      this.toggleClearVisibility();

      if (!this.input.value.length) {
        this.updateAriaLiveContent("");
      }
    });

    this.input.addEventListener("click", () => {
      this.setAttribute("interacting", "");
    });

    this.clearValue = () => {
      this.input.value = "";
      this.updateAriaLiveContent("");
      this.liveSearch.setAttribute("q", "");
      this.toggleClearVisibility();
    };

    const handleClear = () => {
      this.removeAttribute("interacting");
      this.clearValue();
      this.input.focus();
    };

    const handleClose = () => {
      this.dispatchEvent(
        new CustomEvent("header-search:close", { bubbles: true }),
      );

      this.dispatchEvent(
        new CustomEvent("mobile-search:close", { bubbles: true }),
      );

      this.removeAttribute("interacting");
      this.clearValue();
    };

    this.close?.addEventListener("click", handleClose);
    this.clear?.addEventListener("click", handleClear);

    this.addEventListener("live-search-wrapper:clear", this.clearValue);

    this.handleMenuClose = () => {
      this.clearValue();
      this.removeAttribute("interacting");
    };

    document.addEventListener("mobile-menu:closed", this.handleMenuClose);

    this.addEventListener("live-search:updated", (e) => {
      const { ariaLiveContent } = e.detail;
      this.updateAriaLiveContent(ariaLiveContent);
    });
  }

  disconnectedCallback() {
    document.removeEventListener("mobile-menu:closed", this.handleMenuClose);
  }

  toggleClearVisibility() {
    this.toggleAttribute("active", this.input.value.length > 0);
  }

  updateAriaLiveContent(content) {
    const ariaLive = this.querySelector('[aria-live="assertive"]');

    if (!ariaLive) return;

    ariaLive.innerHTML = this.input.value.length ? content : "";
  }
}

if (!customElements.get("live-search-wrapper")) {
  customElements.define("live-search-wrapper", LiveSearchWrapper);
}
